import { useFormikContext } from 'formik'
import { FaCheckCircle } from 'react-icons/fa'

import type { ReactElement } from 'react'
import type { IPageContainerFormValues, ITemplateConfigOptions } from '~/types/template'

import Tabs from '~/components/Tabs'
import { formatTemplateFilterName } from '~/utils/template'

import './styles.scss'

interface Props {
  onSelectorClick: (index: number) => void
  pageIndex: number
  template: ITemplateConfigOptions
}

const Renderer = ({ pageIndex, template }: Props): ReactElement => {
  const { setFieldValue, values } = useFormikContext<IPageContainerFormValues>()

  const handleBlockClick = (placeholderKey: string) => {
    setFieldValue('focus', placeholderKey)
  }

  const currentPage = template.config[pageIndex]

  const { filters } = currentPage

  const tabsData =
    filters?.map((filter) => {
      const itemsCount = currentPage.placeholders.filter(
        ({ filters, placeholderKey }) =>
          filters?.includes(filter) &&
          values.placeholders.filter(({ key }) => key === placeholderKey).some(({ value }) => !value)
      ).length

      return {
        itemsCount: itemsCount > 0 ? itemsCount : undefined,
        label: (
          <>
            {formatTemplateFilterName(filter)} {itemsCount === 0 ? <FaCheckCircle className="check-icon" /> : null}
          </>
        ),
        name: filter,
      }
    }) || []

  return (
    <div className="page-container-renderer-component">
      {!!filters ? (
        <Tabs
          className="template-filter-tabs"
          currentTab={values.templateFilter}
          onClickTab={(tabName) => setFieldValue('templateFilter', tabName)}
          tabsData={tabsData}
        />
      ) : (
        <div className="template-filter-tabs empty" />
      )}
      <template.component onBlockClick={handleBlockClick} pageIndex={pageIndex} templateConfig={template.config} />
    </div>
  )
}

export default Renderer
